import React from 'react';
import PropTypes from 'prop-types';

import { SvgIcon } from 'common/react/components/SvgIcon';

export const SearchResult = ({ result, query }) => {
    const teamAbbreviation = result.team.teamAbbr.toLowerCase();

    const fullName = `${result.playerDetails.givenName} ${result.playerDetails.surname}`;
    const playerProfileURL = PULSE.app.common.url.getPlayerProfileURL(
        result.playerId
    );

    const highlight = (searchQuery, string) => {
        return {
            __html: string.replace(
                new RegExp(searchQuery, 'gi'),
                (str) => `<strong>${str}</strong>`
            )
        };
    };

    return (
        <li className="search-result">
            <a href={playerProfileURL} className="search-result__link">
                <div className="search-result__image">
                    <img
                        loading="lazy"
                        src={PULSE.app.common.image.migratePlayerPhotoURL(
                            result.playerDetails.photoURL,
                            0.1
                        )}
                        alt={`Headshot of ${fullName}`}
                    />
                </div>
                <div className="search-result__details">
                    <p
                        className="search-result__title"
                        dangerouslySetInnerHTML={highlight(query, fullName)}
                    />
                    <div className="search-result__details-team">
                        <SvgIcon
                            icon={`aflc-${teamAbbreviation}-flag`}
                            className={`search-result__details-flag`}
                        />
                        <span>#{result.playerDetails.jumperNumber}</span>
                        <span>|</span>
                        <span>{result.team.teamName}</span>
                    </div>
                </div>
            </a>
        </li>
    );
};

SearchResult.propTypes = {
    result: PropTypes.object.isRequired,
    query: PropTypes.string
};
